export default __webpack_public_path__ + "static/media/email.2e1e69e3.svg";